var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-trash",
    transform: "translate(1740 -79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 37,
    height: 37,
    transform: "translate(-1740 79)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(-1729 89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6889",
    "data-name": "Path 6889",
    d: "M11.843,12.375a.593.593,0,0,1,.593.593v7.116a.593.593,0,0,1-1.186,0V12.968A.593.593,0,0,1,11.843,12.375Zm2.965,0a.593.593,0,0,1,.593.593v7.116a.593.593,0,0,1-1.186,0V12.968A.593.593,0,0,1,14.808,12.375Zm3.558.593a.593.593,0,0,0-1.186,0v7.116a.593.593,0,0,0,1.186,0Z",
    transform: "translate(-7.099 -5.852)",
    fill: "#013871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6890",
    "data-name": "Path 6890",
    d: "M18.793,3.558a1.186,1.186,0,0,1-1.186,1.186h-.593V15.418a2.372,2.372,0,0,1-2.372,2.372H7.526a2.372,2.372,0,0,1-2.372-2.372V4.744H4.561A1.186,1.186,0,0,1,3.375,3.558V2.372A1.186,1.186,0,0,1,4.561,1.186H8.712A1.186,1.186,0,0,1,9.9,0H12.27a1.186,1.186,0,0,1,1.186,1.186h4.151a1.186,1.186,0,0,1,1.186,1.186ZM6.48,4.744l-.14.07v10.6A1.186,1.186,0,0,0,7.526,16.6h7.116a1.186,1.186,0,0,0,1.186-1.186V4.814l-.14-.07ZM4.561,3.558V2.372H17.607V3.558Z",
    transform: "translate(-3.375)",
    fill: "#013871",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.324534485f88dba4e4a0e23ca6d554c1.svg";
export { ForwardRef as ReactComponent };